export default __webpack_public_path__ + "static/media/pamediaLight.55282933.svg";